import React, { Fragment, useEffect, useState } from 'react'
import LeftArrow from "../../assets/images/page/left.png"
import NextArrow from "../../assets/images/page/next.png"
import PreviousArrow from "../../assets/images/page/previous.png"
import RightArrow from "../../assets/images/page/right.png"
import { Col, Row } from 'reactstrap'

const Pagination = ({ pagination, handlePageChange }) => {
    const { pageIndex, pageCount } = pagination
    const [pageNumberArray, setPageNumberArray] = useState([])
    const pageSize = 50
    useEffect(() => {
        setPageNumberArray([])
        const minPage = Math.min(7, pageCount)
        const currentPage = pageIndex + 1

        if (pageCount <= 7) {
            for (let index = 1; index <= minPage; index++) {
                setPageNumberArray(current => [
                    ...current,
                    { page: index, type: "number" },
                ])
            }
        } else {
            const startValue = currentPage - 5
            const endValue = pageCount - currentPage

            let startIndex = 0
            let endIndex = 0

            if (startValue < 0) {
                endIndex = 5
            } else if (startIndex >= 0 && endValue < 4) {
                startIndex = pageCount - 5
                endIndex = pageCount
            } else if (startIndex >= 0 && endValue >= 4) {
                startIndex = currentPage - 2
                endIndex = startIndex + 3
            }

            const startDis = startIndex - 1
            if (startDis > 1) {
                setPageNumberArray(current => [...current])
                setPageNumberArray(current => [
                    ...current,
                ])
            }

            for (let index = startIndex; index < endIndex; index++) {
                setPageNumberArray(current => [
                    ...current,
                    { page: index + 1, type: "number" },
                ])
            }

            let endDis = endIndex - 1
            if (endDis > 1 && startIndex < pageCount - 5) {
                setPageNumberArray(current => [
                    ...current,
                    { page: "...", type: "end" },
                ])
                setPageNumberArray(current => [
                    ...current,
                    { page: pageCount, type: "number" },
                ])
            }
        }
    }, [pagination])

    const gotoPage = page => {
        if (page > 0 && page <= pageCount) handlePageChange(page, pageSize)
    }

    const paginationClick = (pageData, index) => {
        const { page, type } = pageData
        if (type == "number") gotoPage(page)
        else if (type == "start") {
            const nextPage = pageNumberArray[index + 1]
            gotoPage(nextPage.page - 1)
        } else {
            const nextPage = pageNumberArray[index - 1]
            gotoPage(nextPage.page + 1)
        }
    }

    const canNextPage = () => {
        return pageIndex < pageCount
    }

    const canPreviousPage = () => {
        return pageIndex > 1
    }
    return (
        <Row >
            <Col
                md="6"
                className="d-flex justify-content-md-end justify-content-center align-items-center"
            >
                <div className="d-flex gap-1">
                    <img
                        className={`pagination__button pagination__page-first ${!canPreviousPage() ? "pagination__button--disabled" : ""
                            }`}
                        src={LeftArrow}
                        alt="FirstPage"
                        onClick={() => gotoPage(1)}
                        title="Go to First page"
                    />
                    <img
                        className={`pagination__button pagination__page-previous ${!canPreviousPage() ? "pagination__button--disabled" : ""
                            }`}
                        src={PreviousArrow}
                        alt="PrevPage"
                        onClick={() => {
                            gotoPage(pageIndex - 1)
                        }}
                        title="Previous Page"
                    />
                </div>
                <div className="d-flex">
                    {pageNumberArray.map((page, index) => {
                        return (
                            <Fragment key={page.page}>
                                <span
                                    color="primary"
                                    key={page}
                                    onClick={() => {
                                        paginationClick(page, index)
                                    }}
                                    className={`pagination_number ${pageIndex == page.page
                                        ? "pagination_number--selected"
                                        : ""
                                        }`}
                                >
                                    {page.page}
                                </span>
                            </Fragment>
                        )
                    })}
                </div>
                <div className="d-flex gap-1">
                    <img
                        className={`pagination__button pagination__page-first ${!canNextPage() ? "pagination__button--disabled" : ""
                            }`}
                        src={NextArrow}
                        alt="GoToNext"
                        onClick={() => gotoPage(pageIndex + 1)}
                        title="Next Page"
                    />
                    <img
                        className={`pagination__button pagination__page-previous ${!canNextPage() ? "pagination__button--disabled" : ""
                            }`}
                        src={RightArrow}
                        alt="LasPage"
                        onClick={() => {
                            gotoPage(pageCount)
                        }}
                        title="Go to Last Page"
                    />
                </div>
            </Col>
        </Row>
    )
}

export default Pagination
